import addBookmark from 'client/actions/User/addBookmark';
import deleteShowing from './deleteShowing';

export default async function saveShowingForLater(
  inject,
  { tourId, listing, tourCancelReason, onSuccess, userId },
) {
  await Promise.all([
    addBookmark(inject, {
      listingId: listing.id,
      userId: userId || inject.state.get(['currentUser', 'id']),
    }),
    deleteShowing(inject, { tourId, listingId: listing.id, tourCancelReason, onSuccess }),
  ]);
}
